import { render, staticRenderFns } from "./BindSuccess.vue?vue&type=template&id=36428d28&scoped=true"
import script from "./BindSuccess.vue?vue&type=script&lang=js"
export * from "./BindSuccess.vue?vue&type=script&lang=js"
import style0 from "./BindSuccess.vue?vue&type=style&index=0&id=36428d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36428d28",
  null
  
)

export default component.exports